// src/web/TermsAndConditions.jsx

import PageTracker from '../../components/tracking/PageTracker';
import ScrollTracker from '../../components/tracking/ScrollTracker';

function TermsAndConditions() {
  return (
    <div className="legal-page">
      <PageTracker pageName="TermsAndConditions" />

      <section className="legal-content">
        <h1>TERMS & CONDITIONS</h1>

        <p>
          <strong>Version 2.0 — Effective date: August 21, 2026</strong>
        </p>

        <p>
          These Terms & Conditions govern access to and use of the All-Voiced
          website at www.all-voiced.com and the digital services provided
          through All-Voiced.
        </p>

        <p>
          Where acceptance of these Terms is required to create or continue
          using an All-Voiced account, you will be asked to accept them
          explicitly. If you do not agree to these Terms, you should not create
          or continue using an account or use services that are subject to them.
        </p>

        <h3>1. IDENTIFICATION OF THE OWNER</h3>

        <p>The website and digital services are operated by:</p>

        <p>
          <strong>Neus Calaf Gozalo</strong>
          <br />
          Sole trader (self-employed professional)
          <br />
          Spain
          <br />
          Email: support@all-voiced.com
        </p>

        <p>
          All-Voiced is a research-driven initiative focused on
          auditory-perceptual voice assessment, training, research, clinical
          education, and perceptual voice data.
        </p>

        <h3>2. SCOPE OF APPLICATION</h3>

        <p>These Terms & Conditions apply to:</p>

        <ul>
          <li>The use of the All-Voiced website</li>
          <li>The use of the All-Voiced platform</li>
          <li>
            Access to educational, training, research, or informational
            resources
          </li>
          <li>
            Participation in activities, projects, programs, or services
            offered through All-Voiced
          </li>
        </ul>

        <p>
          Certain projects, institutional programs, collaborations, or services
          may also be subject to additional specific terms or documentation.
          Where applicable, those specific conditions complement these Terms.
        </p>

        <h3>3. DESCRIPTION OF THE SERVICES</h3>

        <p>
          All-Voiced provides digital tools and services related to
          auditory-perceptual voice assessment, including training activities,
          structured evaluation workflows, feedback systems, research tools,
          and perceptual data collection.
        </p>

        <p>
          Some features may be freely accessible, while others may be
          restricted to registered users, specific projects, institutional
          programs, collaborations, or paid services.
        </p>

        <p>
          All-Voiced may modify, update, suspend, or discontinue features or
          services where reasonably necessary, subject to applicable law and to
          any specific contractual commitments applicable to paid,
          institutional, or otherwise separately agreed services.
        </p>

        <h3>4. USER RESPONSIBILITIES</h3>

        <p>
          Users agree to use the website and services in good faith and in
          compliance with applicable law.
        </p>

        <p>Users must not:</p>

        <ul>
          <li>Use the website or platform for unlawful purposes</li>
          <li>
            Introduce malware or attempt to interfere with the website or
            platform&apos;s operation
          </li>
          <li>Access, modify, or extract data without authorization</li>
          <li>Misuse training, research, or assessment tools</li>
          <li>Impersonate another person or deliberately provide false information</li>
          <li>
            Attempt to circumvent access restrictions, security measures, or
            other technical safeguards
          </li>
        </ul>

        <h3>5. ACCOUNT REGISTRATION</h3>

        <p>
          Some All-Voiced features require account registration. Users are
          responsible for providing accurate information and maintaining the
          confidentiality of their login credentials.
        </p>

        <p>
          Users are responsible for activity carried out through their account
          and should notify All-Voiced if they become aware of unauthorized
          access or use.
        </p>

        <p>
          All-Voiced may suspend or restrict access to accounts that misuse the
          platform, violate these Terms, or compromise the security or integrity
          of the service.
        </p>

        <h3>6. RESEARCH PARTICIPATION</h3>

        <p>
          Some activities on All-Voiced may be connected to research projects.
          Research participation is voluntary and subject to the corresponding
          information, consent, and data protection procedures.
        </p>

        <p>
          Where research participation requires specific consent, that consent
          will be requested separately from acceptance of these Terms.
        </p>

        <p>
          Users may be asked to provide consent before their data are used for
          research purposes. Refusing or withdrawing research consent does not
          necessarily prevent use of the platform, unless participation in a
          specific project requires such consent.
        </p>

        <p>
          Acceptance of these Terms does not, by itself, constitute consent to
          participate in research or authorization for research use of data.
        </p>

        <h3>7. INTELLECTUAL PROPERTY</h3>

        <p>
          Content made available through the All-Voiced website and platform,
          including text, designs, logos, graphics, educational materials,
          software, and interface elements, is owned by, licensed to, or
          otherwise lawfully used by Neus Calaf Gozalo / All-Voiced unless
          otherwise stated.
        </p>

        <p>
          Third-party materials may be subject to their own copyright, licence,
          attribution, or use conditions.
        </p>

        <p>
          Reproduction, distribution, modification, or commercial use of
          protected All-Voiced content without prior authorization is
          prohibited except where permitted by applicable law or by the
          applicable licence.
        </p>

        <h3>8. USER-GENERATED CONTENT AND DATA</h3>

        <p>
          Users may submit content and may generate responses, evaluations,
          ratings, comments, or other data through the platform.
        </p>

        <p>
          Personal data and research-related data are processed in accordance
          with the Privacy Policy, applicable consent choices, and any relevant
          project-specific documentation.
        </p>

        <p>
          Where users upload or submit recordings, documents, or other
          third-party content, they are responsible for ensuring that they have
          the rights or authorizations necessary to do so.
        </p>

        <p>
          Users must not upload or submit content that is unlawful, harmful,
          discriminatory, defamatory, or infringes third-party rights.
        </p>

        <h3>9. EDUCATIONAL, RESEARCH, AND CLINICAL LIMITATIONS</h3>

        <p>
          All-Voiced provides tools for training, education, research,
          structured evaluation, and data collection. The platform does not
          provide medical diagnosis, treatment, or individual clinical advice.
        </p>

        <p>
          Nothing on this website or platform should be interpreted as a
          substitute for professional clinical judgment, medical consultation,
          or individualized healthcare advice.
        </p>

        <p>
          Results, feedback, comparison data, reference information, or other
          outputs provided through All-Voiced should be interpreted within
          their intended educational, research, or professional context and
          should not be treated as independent clinical conclusions.
        </p>

        <h3>10. LIMITATION OF LIABILITY</h3>

        <p>
          All-Voiced makes reasonable efforts to keep the website and services
          available, accurate, and secure. However, uninterrupted access,
          permanent availability, or error-free operation cannot be guaranteed.
        </p>

        <p>
          To the maximum extent permitted by applicable law, All-Voiced shall
          not be liable for indirect, incidental, or consequential damages
          arising from the use of, or inability to use, the website, platform,
          or related services.
        </p>

        <p>
          Nothing in these Terms excludes or limits liability where such
          exclusion or limitation is not permitted by applicable law.
        </p>

        <h3>11. DATA PROTECTION</h3>

        <p>
          Personal data is processed in accordance with the All-Voiced Privacy
          Policy and applicable data protection regulations, including the
          General Data Protection Regulation (GDPR).
        </p>

        <p>
          Acceptance of these Terms is separate from choices or consents that
          may be requested for specific uses of personal or research data.
        </p>

        <h3>12. GOVERNING LAW AND JURISDICTION</h3>

        <p>These Terms & Conditions are governed by Spanish law.</p>

        <p>
          Where the user qualifies as a consumer, this choice of law does not
          affect any mandatory protections that may apply under the law of the
          user&apos;s country of residence.
        </p>

        <p>
          Any dispute shall be submitted to the courts and tribunals having
          jurisdiction under applicable law, without prejudice to any mandatory
          consumer rights.
        </p>

        <h3>13. MODIFICATIONS TO THESE TERMS</h3>

        <p>
          All-Voiced may update these Terms & Conditions from time to time. The
          current version will be published on this page together with its
          effective date.
        </p>

        <p>
          Where an updated version requires renewed acceptance, registered
          users will be asked to accept the new version before continuing to
          use the services to which the updated Terms apply.
        </p>
      </section>

      <ScrollTracker pageName="TermsAndConditions" />
    </div>
  );
}

export default TermsAndConditions;